import React, { Component } from "react";
import * as Constants from '../../../common/Global/constants';
import { Modal } from "react-bootstrap";
import { AssigmentDetailsIconLayout, DialogSaveButton, FilterCheckBox } from "../../../common/Global/globalStyles.style";
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import PreviousMailDialog from "./PreviousMailDialog";
import AlertDialog from "../../../common/AlertDialog";
import { getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, isEmptyVariable, isValidEmail } from "../../../common/Global/commonFunctions";
import CreatableSelect from "react-select/creatable";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-react-dropdowns/styles/material.css";

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

const employeeDefaultPlaceholder = "Select Employee";
class SendMailDialog extends Component{
    constructor(props){
        super(props);
        this.state = {
            showCcField: false,
            showBccField: false,
            subject: '',
            body: '',
            showPreviousMailDialog: false,
            employeeArr:[],
            emailBody:"",
            footerHtml:"",
            selectedToEmployee: [],
            selectedCCEmployee: [],
            selectedBCCEmployee: [],
            formErrors: {},
            toEmailInputValue: "",
            ccEmailInputValue: "",
            bccEmailInputValue: "",
            copyMailToMe: "N",
            downloadReportList: [],
            selectedReportIds: [],
            submitClickedAtleastOnce: false,
            showAlertDialogInfo: false,
            alertDialogMessageInfo: '',
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
    }

    componentWillUnmount(){
        clearTimeout(this.toEmailErrorTimeout);
        clearTimeout(this.ccEmailErrorTimeout);
        clearTimeout(this.bccEmailErrorTimeout);
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showSendMailDialog){
            this.employeeMasterData();
            this.getDownloadReportList();
            this.getTemplateDefaultMailReportIds();
        }
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({ showAlertDialogInfo: false, alertDialogMessageInfo: '' });
    }

    // Handler to toggle the visibility of Cc and Bcc fields
    handleToggleCc = () => {
        this.setState({ 
            showCcField: true // Once clicked, keep it visible
        });
    }

    handleToggleBcc = () => {
        this.setState({ 
            showBccField: true // Once clicked, keep it visible
        });
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleMailOptionCheck = (event) => {
        const { name, checked } = event.target;
        this.setState({ [name]: checked ? "Y" : "N" });
    }

    // handle for ReactQuill fields
    handleQuillChange = (name, value) => {
        this.setState({ [name]: value });
    }

    showPreviousMail = () => {
        // Logic to show previous mail dialog
        this.setState({ showPreviousMailDialog: true });
    }

    handlePreviousMailDialogClose = () => {
        this.setState({ showPreviousMailDialog: false });
    }

    handleDialogClose = () => {
        clearTimeout(this.toEmailErrorTimeout);
        clearTimeout(this.ccEmailErrorTimeout);
        clearTimeout(this.bccEmailErrorTimeout);
        this.setState({
            showCcField: false,
            showBccField: false,
            subject: '',
            emailBody: '',
            footerHtml: '',
            selectedToEmployee: [],
            selectedCCEmployee: [],
            selectedBCCEmployee: [],
            formErrors: {},
            copyMailToMe: "N",
            downloadReportList: [],
            selectedReportIds: [],
            submitClickedAtleastOnce: false,
        }, () => {
            this.props.handleSendMailDialogClose();
        });
    }

    handleToEmployeeDropdownClick = (item) => {
        let employeeArr = [];
        if(Array.isArray(item)){
            employeeArr = item;
        }else{
            employeeArr.push(item);
        }
        let selectedToEmployee=[];
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedToEmployees'] = "";
        }
        for(var i =0;i<employeeArr.length;i++){
            selectedToEmployee.push(employeeArr[i])
        }

        this.setState({
            selectedToEmployee:selectedToEmployee,
            toEmailInputValue:"",
            formErrors:FormErrorsTemp
        })
    }

    handleCCEmployeeDropdownClick = (item) => {
        let employeeArr = [];
        if(Array.isArray(item)){
            employeeArr = item;
        }else{
            employeeArr.push(item);
        }
        let selectedCCEmployee=[];
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedCCEmployees'] = "";
        }
        for(var i =0;i<employeeArr.length;i++){
            selectedCCEmployee.push(employeeArr[i])
        }

        this.setState({
            selectedCCEmployee:selectedCCEmployee,
            ccEmailInputValue:"",
            formErrors:FormErrorsTemp
        })
    }

    handleBCCEmployeeDropdownClick = (item) => {
        let employeeArr = [];
        if(Array.isArray(item)){
            employeeArr = item;
        }else{
            employeeArr.push(item);
        }
        let selectedBCCEmployee=[];
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedBCCEmployees'] = "";
        }
        for(var i =0;i<employeeArr.length;i++){
            selectedBCCEmployee.push(employeeArr[i])
        }

        this.setState({
            selectedBCCEmployee:selectedBCCEmployee,
            bccEmailInputValue:"",
            formErrors:FormErrorsTemp
        })
    }

    // Allows a freely typed email address to be added as a recipient option,
    // as long as it is a valid email format and isn't already selected/available.
    isValidNewEmailOption = (inputValue, selectValue, selectOptions) => {
        if(isEmptyVariable(inputValue)) return false;
        const trimmed = inputValue.trim();
        if(!isValidEmail(trimmed)) return false;
        const lower = trimmed.toLowerCase();
        const collides = (arr) => (arr||[]).some(o =>
            (o.employeeName||"").toString().toLowerCase() === lower ||
            (o.employeeId||"").toString().toLowerCase() === lower
        );
        return !collides(selectValue) && !collides(selectOptions);
    }

    getNewEmailOptionData = (inputValue) => {
        const trimmed = inputValue.trim();
        return {employeeId: trimmed, employeeName: trimmed, isCustomEmail: true};
    }

    getEmailNoOptionsMessage = ({inputValue}) => {
        if(isEmptyVariable(inputValue)) return "No options";
        return isValidEmail(inputValue.trim()) ? "Already added" : "Enter a valid email address";
    }

    formatCreateEmailLabel = (inputValue) => `Add "${inputValue}"`;

    // Tracks what's currently typed in each recipient field so it can be
    // validated/committed on blur (a user clicking away shouldn't silently lose valid input).
    handleToEmailInputChange = (value, actionMeta) => {
        if(actionMeta.action === "input-change"){
            clearTimeout(this.toEmailErrorTimeout);
            let formErrors = {...this.state.formErrors};
            formErrors['selectedToEmployees'] = "";
            this.setState({ toEmailInputValue: value, formErrors });
        }
    }

    handleCCEmailInputChange = (value, actionMeta) => {
        if(actionMeta.action === "input-change"){
            clearTimeout(this.ccEmailErrorTimeout);
            let formErrors = {...this.state.formErrors};
            formErrors['selectedCCEmployees'] = "";
            this.setState({ ccEmailInputValue: value, formErrors });
        }
    }

    handleBCCEmailInputChange = (value, actionMeta) => {
        if(actionMeta.action === "input-change"){
            clearTimeout(this.bccEmailErrorTimeout);
            let formErrors = {...this.state.formErrors};
            formErrors['selectedBCCEmployees'] = "";
            this.setState({ bccEmailInputValue: value, formErrors });
        }
    }

    // Auto-dismisses a form error after WRNG_MSG_TIMEOUT, same convention used across other forms.
    scheduleEmailErrorClear = (errorKey, timeoutRefKey) => {
        clearTimeout(this[timeoutRefKey]);
        this[timeoutRefKey] = setTimeout(() => {
            let formErrors = {...this.state.formErrors};
            formErrors[errorKey] = "";
            this.setState({ formErrors });
        }, Constants.WRNG_MSG_TIMEOUT);
    }

    // On blur: reject invalid/duplicate email text with an inline error,
    // otherwise commit a valid, not-yet-added address as a recipient (same as pressing Enter would).
    commitOrValidateEmailInput = (inputValue, currentSelection, onChangeHandler, errorKey, inputStateKey, timeoutRefKey) => {
        const trimmed = (inputValue || "").trim();
        if(isEmptyVariable(trimmed)){
            return;
        }
        clearTimeout(this[timeoutRefKey]);
        let formErrors = {...this.state.formErrors};
        if(!isValidEmail(trimmed)){
            formErrors[errorKey] = "Please enter a valid email address";
            this.setState({ formErrors });
            this.scheduleEmailErrorClear(errorKey, timeoutRefKey);
            return;
        }
        const lower = trimmed.toLowerCase();
        const alreadyAdded = (currentSelection||[]).some(o =>
            (o.employeeName||"").toString().toLowerCase() === lower ||
            (o.employeeId||"").toString().toLowerCase() === lower
        );
        if(alreadyAdded){
            formErrors[errorKey] = "This email is already added";
            this.setState({ formErrors, [inputStateKey]: "" });
            this.scheduleEmailErrorClear(errorKey, timeoutRefKey);
            return;
        }
        formErrors[errorKey] = "";
        this.setState({ formErrors, [inputStateKey]: "" }, () => {
            onChangeHandler([...(currentSelection||[]), this.getNewEmailOptionData(trimmed)]);
        });
    }

    handleToEmailBlur = () => {
        this.commitOrValidateEmailInput(this.state.toEmailInputValue, this.state.selectedToEmployee,
            this.handleToEmployeeDropdownClick, 'selectedToEmployees', 'toEmailInputValue', 'toEmailErrorTimeout');
    }

    handleCCEmailBlur = () => {
        this.commitOrValidateEmailInput(this.state.ccEmailInputValue, this.state.selectedCCEmployee,
            this.handleCCEmployeeDropdownClick, 'selectedCCEmployees', 'ccEmailInputValue', 'ccEmailErrorTimeout');
    }

    handleBCCEmailBlur = () => {
        this.commitOrValidateEmailInput(this.state.bccEmailInputValue, this.state.selectedBCCEmployee,
            this.handleBCCEmployeeDropdownClick, 'selectedBCCEmployees', 'bccEmailInputValue', 'bccEmailErrorTimeout');
    }

    modules = {
		toolbar: [
			[{ header: [1, 2, 3, false] }],
			["bold", "italic", "underline", "strike", { color: [] }, { background: [] }],
			[{ list: "ordered" }, { list: "bullet" }, { align: [] }, "link"],
			["clean"],
		],
	};

    employeeMasterData = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.EmployeeNotificationMasterData,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                unitIdList:JSON.stringify(this.props.unitId),
                assignmentId:this.props.assignmentId,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let employeeData = data.employeeList;
                let employees = employeeData.map(item => {
                    item.employeeName = item.salutation+" "+item.firstName+" "+item.lastName;
                    return item;
                })
                let subject = data.subject || '';
                let htmlBody = data.htmlBody || '';
                // Split at <hr> so the footer stays fixed and non-editable
                const hrMatch = htmlBody.match(/<hr\s*\/?>/i);
                let mainBody = htmlBody;
                let footerHtml = '';
                if (hrMatch) {
                    const hrIndex = htmlBody.toLowerCase().indexOf(hrMatch[0].toLowerCase());
                    mainBody = htmlBody.substring(0, hrIndex);
                    footerHtml = htmlBody.substring(hrIndex);
                }

                // Pre-populate To/Cc/Bcc from the last mail sent for this assignment
                let lastMailAddress = data.lastMailAddress || [];
                let selectedToEmployee = [];
                let selectedCCEmployee = [];
                let selectedBCCEmployee = [];
                lastMailAddress.forEach((item) => {
                    let recipient = null;
                    if(!isEmptyVariable(item.employeeId)){
                        recipient = employees.find(emp => emp.employeeId === item.employeeId);
                    }else if(!isEmptyVariable(item.recipientEmail)){
                        recipient = this.getNewEmailOptionData(item.recipientEmail);
                    }
                    if(recipient){
                        if(item.receiverType === "TO"){
                            selectedToEmployee.push(recipient);
                        }else if(item.receiverType === "CC"){
                            selectedCCEmployee.push(recipient);
                        }else if(item.receiverType === "BCC"){
                            selectedBCCEmployee.push(recipient);
                        }
                    }
                })

                this.setState({
                    showLoader:false,
                    employeeArr:employees,
                    emailBody:mainBody,
                    footerHtml:footerHtml,
                    subject:subject,
                    selectedToEmployee:selectedToEmployee,
                    selectedCCEmployee:selectedCCEmployee,
                    selectedBCCEmployee:selectedBCCEmployee,
                    showCcField:this.state.showCcField || selectedCCEmployee.length > 0,
                    showBccField:this.state.showBccField || selectedBCCEmployee.length > 0,
                });
            }else{
                this.setState({
                    showLoader:false,
                });
            }
        });
    }

    // Reports the user can pick from to attach/send with this mail.
    // Only shown/needed on the Completed screen - see the Reports dropdown render check below.
    getDownloadReportList = () => {
        if(this.props.screen !== "completed") return;
        fetch(Constants.GetDownloadReportList, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                departmentId: this.props.departmentId,
            }),
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    downloadReportList: data.data ?? [],
                });
            }
        });
    }

    // Pre-selects whichever reports this assignment's template has marked as its
    // "Default Mail Report" (Settings > Template Setting), via the same /settings/templates API.
    getTemplateDefaultMailReportIds = () => {
        // Only the Completed reports screen passes a templateId to look up - other callers of
        // this shared dialog (e.g. Planning/Scheduled) shouldn't auto-select a default report.
        if(this.props.screen !== "completed" || isEmptyVariable(this.props.templateId)) return;
        fetch(Constants.GetTemplateSetting, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                templateId: this.props.templateId,
            }),
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let settingValue = data.data[0]?.settingDetails?.defaultMailReport?.settingValue;
                let selectedReportIds = isEmptyVariable(settingValue) ? [] : settingValue.split("-").filter(id => id !== "");
                this.setState({
                    selectedReportIds: selectedReportIds,
                });
            }
        });
    }

    handleReportSelect = (args) => {
        let selectedReportIds = this.state.selectedReportIds;
        let newId = args.itemData.clientDownloadReportMapId+"";
        if(!selectedReportIds.includes(newId)){
            this.setState({
                selectedReportIds: [...selectedReportIds, newId],
            });
        }
    }

    handleReportRemove = (args) => {
        let removedId = args.itemData.clientDownloadReportMapId+"";
        this.setState({
            selectedReportIds: this.state.selectedReportIds.filter(id => id !== removedId),
        });
    }

    handleSendMail = () => {
        let formErrors = {};
        const { selectedToEmployee, selectedCCEmployee, selectedBCCEmployee } = this.state;

        if ((!selectedToEmployee || selectedToEmployee.length === 0) &&
            (!selectedCCEmployee || selectedCCEmployee.length === 0) &&
            (!selectedBCCEmployee || selectedBCCEmployee.length === 0)) {
            this.setState({
                showAlertDialogInfo: true,
                alertDialogMessageInfo: "Please select at least one recipient in To, Cc, or Bcc.",
                submitClickedAtleastOnce: true,
            });
            return;
        }

        const toRecipient = (item) => item.isCustomEmail
            ? {departmentId:"", employeeId:"", email: item.employeeId}
            : {departmentId:this.props.departmentId, employeeId: item.employeeId};

        let selectedToEmployees = Object.values(this.state.selectedToEmployee).map(toRecipient);
        let selectedCCEmployees = Object.values(this.state.selectedCCEmployee).map(toRecipient);
        let selectedBCCEmployees = Object.values(this.state.selectedBCCEmployee).map(toRecipient);

        fetch(Constants.EmployeeNotification,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                assignmentId:this.props.assignmentId,
                mailToList:JSON.stringify(selectedToEmployees),
                mailCCList:JSON.stringify(selectedCCEmployees),
                mailBCCList:JSON.stringify(selectedBCCEmployees),
                subject:this.state.subject,
                mailHtml:this.state.emailBody + this.state.footerHtml,
                previousReportList:JSON.stringify(this.state.selectedReportIds.map(id => parseInt(id))),
                sendCopyToMe:this.state.copyMailToMe,
                screen:this.props.screen
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader: false,
                    subject: '',
                    emailBody: '',
                    footerHtml: '',
                    selectedToEmployee: [],
                    selectedCCEmployee: [],
                    selectedBCCEmployee: [],
                    showCcField: false,
                    showBccField: false,
                    formErrors: {},
                    copyMailToMe: "N",
                    downloadReportList: [],
                    selectedReportIds: [],
                    submitClickedAtleastOnce: false,
                }, () => {
                    this.props.handleSendMailDialogClose();
                });
            }else{
                this.setState({
                    showLoader: false,
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo: data.responseMessage || "Failed to send mail. Please try again.",
                });
            }
        })
        .catch(() => {
            this.setState({
                showLoader: false,
                showAlertDialogInfo: true,
                alertDialogMessageInfo: "Something went wrong. Please try again.",
            });
        });
    }

    render(){
        const { showCcField, showBccField, selectedToEmployee, selectedCCEmployee, selectedBCCEmployee, subject, body } = this.state;
        
        // Gather all selected employee IDs across To, Cc, and Bcc
        const selectedEmployeeIds = [
            ...(selectedToEmployee || []),
            ...(selectedCCEmployee || []),
            ...(selectedBCCEmployee || [])
        ].map(emp => emp.employeeId);

        // Also remove the current user from the main list (already done in your code, but good practice to ensure)
        const currentUserId = userDetails.employeeId;

        // 2. Filter the main employee list to exclude selected and current user IDs
        const availableEmployees = this.state.employeeArr.filter(emp => 
            !selectedEmployeeIds.includes(emp.employeeId) && emp.employeeId !== currentUserId
        );

        // 3. Define the available employee list for each dropdown based on what's selected in the OTHERS
        const availableForTo = this.state.employeeArr.filter(emp => 
            !(selectedCCEmployee || []).map(e => e.employeeId).includes(emp.employeeId) &&
            !(selectedBCCEmployee || []).map(e => e.employeeId).includes(emp.employeeId) &&
            emp.employeeId !== currentUserId
        );

        const availableForCC = this.state.employeeArr.filter(emp => 
            !(selectedToEmployee || []).map(e => e.employeeId).includes(emp.employeeId) &&
            !(selectedBCCEmployee || []).map(e => e.employeeId).includes(emp.employeeId) &&
            emp.employeeId !== currentUserId
        );
        
        const availableForBCC = this.state.employeeArr.filter(emp => 
            !(selectedToEmployee || []).map(e => e.employeeId).includes(emp.employeeId) &&
            !(selectedCCEmployee || []).map(e => e.employeeId).includes(emp.employeeId) &&
            emp.employeeId !== currentUserId
        );
        return(
            <section>
                <Modal enforceFocus={false} className="task-select-dept-dialog custom-dialog" size="md"
                    show={this.props.showSendMailDialog}
                    backdrop="static">
                    <Modal.Header>
                        {
                            <h5>Send Mail</h5>
                        }
                        <button
                            onClick={this.handleDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>

                    <hr />
                    <div className="modal-body p-0 d-flex flex-column" style={{ minHeight: '400px' }}>
                        
                        {/* 1. Address Fields (To, Cc, Bcc) */}
                        <div className="email-header-fields flex-shrink-0">
                            
                            {/* TO Field - Always visible */}
                            <div className="d-flex align-items-center email-field-row border-bottom">
                                <span className="email-field-label text-muted px-3">To</span>
                                <div className="flex-grow-1 p-2">
                                    <CreatableSelect
                                        value={this.state.selectedToEmployee}
                                        onChange={this.handleToEmployeeDropdownClick}
                                        onInputChange={this.handleToEmailInputChange}
                                        onBlur={this.handleToEmailBlur}
                                        options={availableForTo}
                                        getOptionLabel={(option) => option.employeeName}
                                        getOptionValue={(option) => option.employeeId}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder={employeeDefaultPlaceholder}
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        isValidNewOption={this.isValidNewEmailOption}
                                        getNewOptionData={this.getNewEmailOptionData}
                                        noOptionsMessage={this.getEmailNoOptionsMessage}
                                        formatCreateLabel={this.formatCreateEmailLabel}
                                    />
                                    {
                                        !isEmptyVariable(this.state.formErrors['selectedToEmployees']) &&
                                        <span class="cm-error">{this.state.formErrors['selectedToEmployees']}</span>
                                    }
                                </div>
                                {/* Conditional display of CC/BCC toggles */}
                                <div className="email-controls p-2 d-flex">
                                    {!showCcField && (
                                        <button 
                                            className="btn p-0 mr-2 text-decoration-none" 
                                            onClick={this.handleToggleCc}
                                        >
                                            Cc
                                        </button>
                                    )}
                                    {!showBccField && (
                                        <button 
                                            className="btn p-0 text-decoration-none" 
                                            onClick={this.handleToggleBcc}
                                        >
                                            Bcc
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* CC Field - Conditionally displayed */}
                            {showCcField && (
                                <div className="d-flex align-items-center email-field-row border-bottom">
                                    <span 
                                        className="d-flex email-field-label px-3 align-items-center" 
                                    >
                                        Cc 
                                        {/* <span className="material-icons dropdown-icon">expand_more</span> */}
                                    </span>
                                    <div className="flex-grow-1 p-2">
                                        <CreatableSelect
                                            value={this.state.selectedCCEmployee}
                                            onChange={this.handleCCEmployeeDropdownClick}
                                            onInputChange={this.handleCCEmailInputChange}
                                            onBlur={this.handleCCEmailBlur}
                                            options={availableForCC}
                                            getOptionLabel={(option) => option.employeeName}
                                            getOptionValue={(option) => option.employeeId}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder={employeeDefaultPlaceholder}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                            isValidNewOption={this.isValidNewEmailOption}
                                            getNewOptionData={this.getNewEmailOptionData}
                                            noOptionsMessage={this.getEmailNoOptionsMessage}
                                            formatCreateLabel={this.formatCreateEmailLabel}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['selectedCCEmployees']) &&
                                            <span class="cm-error">{this.state.formErrors['selectedCCEmployees']}</span>
                                        }
                                    </div>
                                </div>
                            )}

                            {/* BCC Field - Conditionally displayed */}
                            {showBccField && (
                                <div className="d-flex align-items-center email-field-row border-bottom">
                                    <span 
                                        className="d-flex email-field-label px-3 align-items-center"
                                    >
                                        Bcc 
                                        {/* <span className="material-icons dropdown-icon">expand_more</span> */}
                                    </span>
                                    <div className="flex-grow-1 p-2">
                                        <CreatableSelect
                                            value={this.state.selectedBCCEmployee}
                                            onChange={this.handleBCCEmployeeDropdownClick}
                                            onInputChange={this.handleBCCEmailInputChange}
                                            onBlur={this.handleBCCEmailBlur}
                                            options={availableForBCC}
                                            getOptionLabel={(option) => option.employeeName}
                                            getOptionValue={(option) => option.employeeId}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder={employeeDefaultPlaceholder}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                            isValidNewOption={this.isValidNewEmailOption}
                                            getNewOptionData={this.getNewEmailOptionData}
                                            noOptionsMessage={this.getEmailNoOptionsMessage}
                                            formatCreateLabel={this.formatCreateEmailLabel}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['selectedBCCEmployees']) &&
                                            <span class="cm-error">{this.state.formErrors['selectedBCCEmployees']}</span>
                                        }
                                    </div>
                                </div>
                            )}

                            {/* Mail Options */}
                            <div className="d-flex align-items-center email-field-row px-3 py-2">
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}>
                                    <input
                                        type="checkbox"
                                        name="copyMailToMe"
                                        id="copyMailToMe"
                                        onChange={this.handleMailOptionCheck}
                                        checked={this.state.copyMailToMe === "Y"}
                                    />
                                    <label for="copyMailToMe">Copy mail to me</label>
                                </FilterCheckBox>
                            </div>

                            {/* SUBJECT Field */}
                            <div className={`d-flex align-items-center email-field-row border-bottom}`}>
                                <span className="email-field-label text-muted px-3">Subject</span>
                                <input 
                                    type="text" 
                                    name="subject" 
                                    className="form-control-plaintext flex-grow-1 border-0 p-2" 
                                    placeholder="" 
                                    value={subject}
                                    onChange={this.handleInputChange}
                                />
                            </div>

                        </div>

                        {/* 2. Email Body Area */}
                        <div className="email-body-content flex-grow-1 overflow-auto d-flex flex-column">
                            <div className="flex-grow-1">
                                <ReactQuill
                                    placeholder={""}
                                    value={this.state.emailBody}
                                    id={"emailBody"}
                                    onChange={this.handleQuillChange.bind(this,"emailBody")}
                                    className={"two-lines-focus mail-body-quill"}
                                    modules={this.modules}
                                />
                            </div>
                            {this.state.footerHtml && (
                                <div
                                    className="px-3 mail-footer-html"
                                    style={{pointerEvents:'none', userSelect:'none', marginTop:'16px'}}
                                    dangerouslySetInnerHTML={{ __html: this.state.footerHtml }}
                                />
                            )}
                            {this.props.screen === "completed" && (
                                <div className="px-3" style={{ marginTop: 0 }}>
                                    <p className="m-b-0" style={{fontSize:12, fontWeight:600}}>Reports</p>
                                    <MultiSelectComponent
                                        key={"sendMailReports:-:"+this.state.downloadReportList.length+":-:"+this.state.selectedReportIds.join(",")}
                                        dataSource={this.state.downloadReportList}
                                        fields={{text:"displayReportName", value:"clientDownloadReportMapId"}}
                                        placeholder="Select Reports"
                                        mode="CheckBox"
                                        closePopupOnSelect={false}
                                        allowFiltering={true}
                                        select={this.handleReportSelect}
                                        removed={this.handleReportRemove}
                                        cssClass="clientsChecklist dialogcl"
                                        value={this.state.selectedReportIds.map(id => parseInt(id))}
                                        showDropDownIcon={true}
                                        showClearButton={true}
                                    >
                                        <Inject services={[CheckBoxSelection]} />
                                    </MultiSelectComponent>
                                </div>
                            )}
                        </div>

                        <div className="modal-close-save m-t-15 mb-3 d-flex justify-content-between align-items-center">
                            <span className="tool ml-4 previous-mail" data-title="Previous Mail">
                                <AssigmentDetailsIconLayout themeSettings={this.props.themeSettings}>
                                    <span className="material-icons" style={{fontSize:28}} onClick={this.showPreviousMail}>email</span>
                                </AssigmentDetailsIconLayout>
                            </span>
                            <div className="close-save-col mx-auto">
                                <button onClick={this.handleDialogClose} type="button" className="modal-close m-b-0">Cancel</button>
                                <DialogSaveButton
                                    themeSettings={this.props.themeSettings} 
                                    type="button" 
                                    className="modal-save m-b-0"
                                    onClick={this.handleSendMail}
                                >
                                    Send
                                </DialogSaveButton>
                            </div>
                            <div style={{ width: '30px' }}></div>
                        </div>
                    </div>
                </Modal>
                <PreviousMailDialog
                    showPreviousMailDialog={this.state.showPreviousMailDialog}
                    handlePreviousMailDialogClose={this.handlePreviousMailDialogClose}
                    themeSettings={this.props.themeSettings}
                    assignmentId={this.props.assignmentId}
                    screen={this.props.screen}
                />
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </section>
        )
    }
}
export default SendMailDialog;